import React, { FunctionComponent } from 'react';

import { MenuProps, Menu as OrbMenu } from '@yandex-360/orb-components/dist/components/Menu2';
import cn from 'classnames';

import css from './styles.css';

export const Menu: FunctionComponent<MenuProps> = ({ className, ...props }) => {
    const menuClasses = cn(css.menu, className);

    return <OrbMenu {...props} className={menuClasses} />;
};

Menu.displayName = 'SettingsModal.Menu';
